import React from "react";
import { Clock } from "lucide-react";
import { Loader } from "./PageHead";
import { technicianColor } from "../lib/techColors";

function ageClass(days) {
  if (days == null) return "normal";
  if (days <= 7) return "normal";
  if (days <= 14) return "warn";
  return "over";
}

// Technician columns × status-group rows — the Technical Dashboard's
// replacement for the Job Flow Board's stage-column kanban (that board is
// untouched; this is a separate view keyed by WHO has the work, not WHAT
// stage it's in).
export function WorkByTechnicianBoard({ data, loading, onOpenItem }) {
  const technicians = data?.technicians || [];
  const names = technicians.map((t) => t.technician);

  if (loading) return <Loader />;
  if (!technicians.length) {
    return <div className="t-mut" style={{ padding: "24px 4px" }} data-testid="td-board-empty">No items match the current filters.</div>;
  }

  return (
    <>
      {data?.truncated && (
        <div className="t-mut" style={{ fontSize: 11.5, marginBottom: 8 }} data-testid="td-board-truncated-note">
          Showing first {data.total_items} of {data.total_matching} matching items — refine filters to see the rest.
        </div>
      )}
      <div className="td-board" data-testid="td-board">
        {technicians.map((t) => {
        const color = technicianColor(t.technician, names);
        return (
          <div className="td-board-col" key={t.technician} data-testid={`td-col-${t.technician}`}>
            <div className="td-board-col-head">
              <span className="td-dot" style={{ background: color }} />
              <span className="td-col-name">{t.technician}</span>
              <span className="td-col-total">{t.total} items</span>
            </div>
            <div className="td-board-col-body">
              {t.groups.map((g) => (
                <div key={g.label} className="td-status-group">
                  <div className="td-status-head">{g.label} <span>{g.count}</span></div>
                  {g.items.map((it) => {
                    const cls = ageClass(it.days_in_system);
                    return (
                      <div
                        key={it.id}
                        className="td-item-card"
                        data-testid={`td-item-${it.id}`}
                        onClick={() => onOpenItem?.(it.job_id)}
                      >
                        <div className="td-item-top">
                          <span className="mono">{it.delivery_note_number || "—"}</span>
                          <span className={`td-age ${cls}`}>
                            <Clock size={9} style={{ verticalAlign: -1, marginRight: 2 }} />
                            {it.days_in_system != null ? `${it.days_in_system}d` : "—"}
                          </span>
                        </div>
                        <div className="td-item-desc">{it.description || "Unnamed item"}</div>
                        <div className="td-item-meta">
                          <span>{it.discipline || "—"}</span>
                          {it.customer_name && <span>· {it.customer_name}</span>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        );
      })}
      </div>
    </>
  );
}
